export default __webpack_public_path__ + "static/media/pod.c9deb26e.png";